module.exports = __webpack_public_path__ + "img/ហាន.13c753b9.png";